import React from "react";

/** Shared split/merge symbol used by the C1 button editor and channel menus. */
export function ButtonRowModeIcon({ x = 0, y = 0, isSplit }: { x?: number; y?: number; isSplit: boolean }) {
  return <>
      <rect x={x - 9} y={y - 5.5} width="18" height="11" rx="5.5" />
      {isSplit ? (
        <path d={`M ${x - 5} ${y}h4m-2-2 2 2-2 2M ${x + 5} ${y}h-4m2-2-2 2 2 2`} />
      ) : (
        <path d={`M ${x - 1} ${y}h-4m2-2-2 2 2 2M ${x + 1} ${y}h4m-2-2 2 2-2 2`} />
      )}
  </>;
}
